module.exports = __webpack_public_path__ + "img/visio.97835c87.jpg";